import { useEffect, useState } from 'react';
import { useSchemaDesignerStore } from '@/stores/schema-designer-store';
import { RiCheckLine, RiLoader4Line, RiTimeLine } from '@remixicon/react';
import { cn } from '@/lib/utils';
import { formatDistanceToNow } from 'date-fns';

export const SaveStatusIndicator = () => {
  const { lastSaveTime, isSaving, syncStatus } = useSchemaDesignerStore();
  const [showSaved, setShowSaved] = useState(false);

  useEffect(() => {
    if (lastSaveTime) {
      setShowSaved(true);
      const timer = setTimeout(() => setShowSaved(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [lastSaveTime]);

  const isCloudSaving = syncStatus === 'saving' || isSaving;
  const hasError = syncStatus === 'error';

  if (!lastSaveTime && !isCloudSaving) return null;

  return (
    <div
      className={cn(
        'flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-all',
        'bg-background border border-border shadow-sm',
        hasError && 'border-destructive/50 bg-destructive/5 text-destructive',
        isCloudSaving && 'border-blue-500/50 bg-blue-500/5 text-blue-600',
        showSaved && !isCloudSaving && !hasError && 'border-green-500/50 bg-green-500/5 text-green-600'
      )}
    >
      {isCloudSaving ? (
        <>
          <RiLoader4Line className="h-3.5 w-3.5 animate-spin" />
          <span>Saving...</span>
        </>
      ) : hasError ? (
        <>
          <RiTimeLine className="h-3.5 w-3.5" />
          <span>Save failed</span>
        </>
      ) : showSaved ? (
        <>
          <RiCheckLine className="h-3.5 w-3.5" />
          <span>Saved</span>
        </>
      ) : lastSaveTime ? (
        <>
          <RiCheckLine className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-muted-foreground">
            Saved {formatDistanceToNow(lastSaveTime, { addSuffix: true })}
          </span>
        </>
      ) : null}
    </div>
  );
};
